import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import { AttendanceHeader, AttendanceTable, FilterAttendanceByDay } from '@/components/pages/Attendance'
import { useAttendance } from '@/pages/Attendance/Attendance.hooks'
import { useClient } from '@/pages/Client/Client.hooks'
import { useClientDeviceByDay } from '@/pages/ClientDevice/ClientDeviceByDay.hooks'
import { useEmployees } from '@/pages/Employees/Employees.hooks'

export type SearchEmployee = {
  gender?: string
  position?: string
  department?: string
}

const searchEmployeeDefault = {
  gender: '-1',
  position: '-1',
  department: '-1',
}

const Attendance: React.FC = () => {
  const [searchParams] = useSearchParams()
  const filterDay = searchParams.get('filterDay')
  const [date, setDate] = useState(filterDay ? filterDay : undefined)
  const [employeeId, setEmployeeId] = useState<number>()
  const [isNotError, setNotError] = useState(true)
  const [searchEmployee, setSearchEmployee] = useState<SearchEmployee>(searchEmployeeDefault)

  const {
    getAttendance,
    getAttendanceResponse,
    attendanceLoading,
    updateAttendance,
    updateAttendanceLoading,
    createAttendance,
    createAttendanceLoading,
    deleteAttendance,
  } = useAttendance()

  const { getClients, response } = useClient()

  const { getClientDeviceByDay, responseClientDevice } = useClientDeviceByDay()

  const { allEmployeesResponse, getAllEmployees } = useEmployees()

  useEffect(() => {
    if (date) {
      if (!employeeId || employeeId === -1) {
        getAttendance({
          date,
          employeeId: employeeId !== -1 ? employeeId : undefined,
          isNotError,
          gender: searchEmployee.gender !== '-1' ? searchEmployee.gender : undefined,
          department: searchEmployee.department !== '-1' ? searchEmployee.department : undefined,
          position: searchEmployee.position !== '-1' ? searchEmployee.position : undefined,
        })
      } else {
        getAttendance({
          date,
          employeeId,
          isNotError,
        })
      }
    }
  }, [date, searchEmployee, employeeId, getAttendance, isNotError, filterDay])

  useEffect(() => {
    if (date) {
      getClientDeviceByDay({ date })
    }
  }, [date, getClientDeviceByDay])

  useEffect(() => {
    getClients()
    getAllEmployees({})
  }, [getAllEmployees, getClients])

  return (
    <>
      <AttendanceHeader />
      <FilterAttendanceByDay
        setNotError={setNotError}
        date={date}
        setEmployeeId={setEmployeeId}
        employeeId={employeeId}
        setDate={setDate}
        isNotError={isNotError}
        setSearchEmployee={setSearchEmployee}
        searchEmployee={searchEmployee}
      />
      <AttendanceTable
        getAttendanceResponse={getAttendanceResponse}
        getAttendance={getAttendance}
        date={date}
        isNotError={isNotError}
        employeeId={employeeId}
        attendanceLoading={attendanceLoading}
        updateAttendance={updateAttendance}
        updateAttendanceLoading={updateAttendanceLoading}
        createAttendance={createAttendance}
        createAttendanceLoading={createAttendanceLoading}
        responseClientDevice={responseClientDevice}
        deleteAttendance={deleteAttendance}
        response={response}
        allEmployeesResponse={allEmployeesResponse}
      />
    </>
  )
}
Attendance.displayName = 'Attendance'
export default Attendance
